export const OUTLIER_COLOR_LIGHT = "#fca0a1"

export const OUTLIER_COLOR_DARK = "#FF0000FF"
export const ALLOWED_COLOR_LIGHT = "#F6E5BBFF"
export const ALLOWED_COLOR_DARK = "#FF8000FF"
export const TRANSPARENT = "transparent"
export const FAVORED_COLOR_DARK = "#009933"
export const FAVORED_COLOR_LIGHT = "#D9F8C1FF"


export const getCompressionColor = (compression, outlierLowerBound, allowedLowerBound) => {
    if (!compression) return TRANSPARENT
    if (compression && (compression < outlierLowerBound)) return OUTLIER_COLOR_LIGHT;
    if (compression && (outlierLowerBound <= compression && compression < allowedLowerBound)) return ALLOWED_COLOR_LIGHT;
    return FAVORED_COLOR_LIGHT;
}